import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import InstallAppBannerContainer from "commons/banner/InstallAppBanner.container";
import * as AlarmApi from "api/school/v2/alarm.api";
import AlarmTooltip from "./AlarmTooltip";

const Header = (props: any) => {
    const { info: myInfo } = useSelector((state: any) => state.user);
    const [showAlarmTooltip, setShowAlarmTooltip] = useState(false);
    const [unreadCount, setUnreadCount] = useState(0);

    useEffect(() => {
        console.log("myInfo", myInfo);
    }, [myInfo]);

    useEffect(() => {
        const fetchUnreadCount = async () => {
            try {
                const response = await AlarmApi.getUnreadAlarmCount();
                setUnreadCount(response.count);
            } catch (error) {
                console.error("읽지 않은 알람 수 조회 실패:", error);
            }
        };

        // 초기 실행
        fetchUnreadCount();

        let interval: any = null;
        // 10초마다 실행
        if (process.env.REACT_APP_ENV != 'local') {
            interval = setInterval(() => {
                fetchUnreadCount();
            }, 10000);
        }

        // 컴포넌트 언마운트 시 인터벌 정리
        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, []);

    const handleAlarmClick = () => {
        setShowAlarmTooltip(!showAlarmTooltip);
        setUnreadCount(0);
    };

    const onCloseAlarmTooltip = () => {
        setShowAlarmTooltip(false);
    };

    return (
        <header className="fixed top-0 left-0 right-0 w-full bg-white shadow z-50">
            <div className="max-w-7xl mx-auto px-4">
                <div className="py-2 flex justify-between items-center">
                    <Link to="/school" className="inline-block">
                        <img
                            src="./imgs/common/logo/img-logo/logo-t2-125.png"
                            alt="wannabes"
                            className="w-[40px] md:w-[35px] sm:w-[25px]"
                        />
                    </Link>

                    <div className="flex items-center gap-4">
                        <button onClick={handleAlarmClick} className="text-gray-600 hover:text-gray-900 relative">
                            <img src="./imgs/icons/alarm-icon.png" alt="알림" className="w-7 h-7 sm:w-5 sm:h-5" />
                            {unreadCount > 0 && (
                                <div className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-red-500 rounded-full animate-pulse"></div>
                            )}
                        </button>
                        <Link to="/school/my" className="text-gray-600 hover:text-gray-900">
                            <img
                                src={myInfo?.profileImage}
                                alt="프로필"
                                className="w-[40px] h-[40px] md:w-[35px] md:h-[35px] sm:w-[25px] sm:h-[25px] rounded-full object-cover"
                            />
                        </Link>
                    </div>
                </div>
            </div>
            {/* 모바일 웹에서 앱 설치 유도 배너 */}
            <InstallAppBannerContainer />
            {showAlarmTooltip && <AlarmTooltip onClose={onCloseAlarmTooltip} />}
        </header>
    );
};

export default Header;